<script setup lang="ts">
import type { Contract } from '~/layers/forms/models'

defineProps<{
  data: Contract
}>()

const { visible } = useVisible()
const selectedData = ref<keyof Contract>('customer')
</script>
<template>
  <PvButton
    class="flex items-center gap-2 leading-none"
    @click="visible = !visible"
  >
    <span class="icon-[ph--file-text] text-xl" />
    <span class="font-bold">FORM</span>
  </PvButton>
  <PvDialog
    v-model:visible="visible"
    class="w-[90%] max-w-[90%] md:w-[75rem]"
    :closable="false"
  >
    <div class="flex justify-between p-8">
      <TitleComponent
        text="Form"
        no-caps
        type="subtitle"
        icon-class="icon-[ph--file]"
      />
      <PvButton
        severity="contrast"
        @click="visible = !visible"
      >
        <span class="icon-[ph--x-circle] text-xl" />
      </PvButton>
    </div>
    <PvDivider />
    <div class="grid gap-4 p-8">
      <div class="flex flex-wrap gap-2">
        <template
          v-for="(_, key) in data"
          :key="key"
        >
          <PvButton
            :severity="selectedData === key ? 'primary' : 'secondary'"
            :outlined="selectedData !== key"
            @click="selectedData = key"
          >
            {{ key }}
          </PvButton>
        </template>
      </div>
      <JsonViewerComponent
        v-if="selectedData"
        :value="{ contract: data[selectedData] }"
      />
    </div>
  </PvDialog>
</template>
